<template>
    <div class="codics-aonaer-info-sys-poster-body">
        <WebHeader></WebHeader>
        <BreadCrumb style="margin-top: 100px;" :bread-list="breadList">
            <el-cascader class="codics-aonaer-info-sys-video-pick"
                style="float: right;top: 50%;transform: translateY(-50%);" v-model="nowType" placeholder="请选择海报分类"
                filterable :options="typeData"
                :props="{ checkStrictly: true, value: 'id', label: 'value', children: 'data' }" clearable
                @change="yearPosterFuc"></el-cascader>
        </BreadCrumb>
        <div class="codics-aonaer-info-sys-poster-year-tab-box">
            <div class="codics-aonaer-info-sys-poster-year-tab-container">
                <div class="codics-aonaer-info-sys-poster-year-tab-item" v-for="(item, index) in yearList" :key="index"
                    :style="{ color: index == yearIndex ? '#FFF' : '#222', background: index == yearIndex ? '#ea5b18' : '#F7F7F7' }"
                    @click="yearIndex = index;">
                    {{ item }}年
                </div>
            </div>
        </div>
        <div class="codics-aonaer-info-sys-poster-swiper-box">
            <div class="codics-aonaer-info-sys-poster-swiper-box-container">
                <div class="swiper-container codics-aonaer-info-sys-poster-swiper">
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in haibaoData" :key="index.id" class="swiper-slide">
                            <div class="swiper-slide-card codics-aonaer-info-sys-poster-swiper-item">
                                <div class="codics-aonaer-info-sys-poster-swiper-item-time">{{ initTime(item.stime) }}
                                </div>
                                <div class="codics-aonaer-info-sys-poster-swiper-item-pl"></div>
                                <div class="codics-aonaer-info-sys-poster-swiper-item-card-box">
                                    <div class="codics-aonaer-info-sys-poster-swiper-item-card">
                                        <div class="codics-aonaer-info-sys-poster-swiper-item-card-img"
                                            :data-content="'春节海报'">
                                            <img :src="initImg(item.img)">
                                        </div>
                                        <div class="codics-aonaer-info-sys-poster-swiper-item-card-btn"
                                            @click="jumpToPage('海报详情', { id: item.id }, {})">查看详情</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div
                        class="swiper-button-next codics-aonaer-info-sys-poster-swiper-btn codics-aonaer-info-sys-poster-swiper-next iconfont">
                        &#xe844;
                    </div>
                    <div
                        class="swiper-button-prev codics-aonaer-info-sys-poster-swiper-btn codics-aonaer-info-sys-poster-swiper-prev iconfont">
                        &#xe842;
                    </div>
                </div>
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import BreadCrumb from '@/components/BreadCrumb';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import dayjs from 'dayjs';
import { yearPoster, listPosterType } from '@/api';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            yearIndex: 0,
            yearList: [2025, 2024],
            nowType: 0,
            typeData: [],
            breadList: [
                {
                    title: '网站首页',
                    url: '#'
                },
                {
                    title: '奥纳尔',
                    url: '#'
                },
                {
                    title: '朋友圈节日海报',
                    url: '#'
                }
            ],
            haibaoData: [
            ]
        }
    },
    mounted() {
        // 初始化海报轮播
        this.initSwiper();

        this.yearPosterFuc();

        this.listPosterTypeFuc();

    },
    methods: {
        async listPosterTypeFuc() {

            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listPosterType();

            loading.close();

            if (data.code == 200) {

                this.typeData = data.data;

                this.initChildren(this.typeData);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initChildren(list) {

            for (var i = 0; i < list.length; i++) {

                if (list[i]?.data != null) {

                    // list[i].hasChildren = true;

                    this.initChildren(list[i].data);

                } else {

                    // delete list[i].children;

                }

            }

        },
        checkDevice() {
            // 通常认为小于768px为手机，但这只是一个大致的判断标准，具体可以根据需要调整
            return window.innerWidth < 768;
        },
        initImg(str) {
            return str == '' ? '' : ('https://cdn.bosscaigou.com/' + str.split(',')[0]);
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD');
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        async yearPosterFuc() {

            let data = await yearPoster({ year: this.$route.params.year, type: this.nowType });

            if (data.code == 200) {

                this.haibaoData = data.data.reverse();

                this.yearList = data.data1;

            } else {

                this.$message.error(data.message);

            }

        },
        initSwiper() {
            let _this = this;
            this.swiper = new Swiper(".swiper-container", {
                loop: false, // 无缝
                autoplay: { //自动开始
                    delay: 8000, //时间间隔
                    disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                },
                paginationClickable: true,
                fade: { crossFade: true },
                slidesPerView: this.checkDevice() ? 2 : 6, // 一组三个
                spaceBetween: 0, // 间隔
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
                observer: true,
                observeParents: true,
                // 如果需要分页器
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true, // 分页器可以点击
                // },
                on: {
                    click: (e) => {

                        var clickedSlide = e.target.closest('.swiper-slide');
                        if (clickedSlide) {
                            // console.log(clickedSlide, _this.swiper.slides)
                            // 获取点击元素的index
                            var index = Array.from(_this.swiper.slides).indexOf(clickedSlide);
                            // console.log('Clicked slide index:', index % 5);
                            this.swiper && this.swiper.slideTo(index % 5, 300);
                        }

                    },
                    transitionEnd: function () {
                        if (_this.swiperState) {
                            // console.log(this.realIndex)
                            _this.flyTo({
                                position: _this.swiperList[this.realIndex].from || [0, 200, 0],
                                controls: _this.swiperList[this.realIndex].to || [0, 0, 0],
                                done: () => {

                                }
                            })
                        }
                    }
                },
            })
        },
    },
    components: {
        WebHeader,
        WebFooter,
        BreadCrumb
    }
}
</script>

<style>
.codics-aonaer-info-sys-poster-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-aonaer-info-sys-poster-year-tab-box {
    height: 120px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 40px 0;
}

.codics-aonaer-info-sys-poster-year-tab-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 5px;
}

.codics-aonaer-info-sys-poster-year-tab-item {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 40px;
    text-align: center;
    padding: 0 40px;
    font-size: 16px;
    cursor: pointer;
    transition: .3s;
    color: #222;
    border-radius: 20px;
    background: #F7F7F7;
    margin-right: 15px;
}

.codics-aonaer-info-sys-poster-year-tab-item:hover {
    background: #ea5b18 !important;
    color: #FFF !important;
}

.codics-aonaer-info-sys-poster-swiper-box {
    height: 530px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-bottom: 50px;
}

.codics-aonaer-info-sys-poster-swiper-box-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
}

.codics-aonaer-info-sys-poster-swiper {
    height: 530px;
    width: 100%;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-poster-swiper-item {
    height: 100%;
    cursor: pointer;
}

.codics-aonaer-info-sys-poster-swiper-item-time {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 30px;
    font-size: 20px;
    font-family: "dinpro-Regular" !important;
    text-align: center;
    color: #222;
}

.codics-aonaer-info-sys-poster-swiper-item-pl {
    height: 62px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-poster-swiper-item-pl::before {
    content: '';
    height: .1px;
    width: 100%;
    position: absolute;
    margin: auto;
    top: -15px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .05);
}

.codics-aonaer-info-sys-poster-swiper-item-pl::after {
    content: '';
    height: 12px;
    width: 12px;
    position: absolute;
    margin: auto;
    top: -15px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #fff;
    transition: .3s;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-poster-swiper-item:hover .codics-aonaer-info-sys-poster-swiper-item-pl::after {
    border: 1px solid #ea5b18;
    background-color: #ea5b18;
}

.codics-aonaer-info-sys-poster-swiper-item-card-box {
    height: calc(100% - 92px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

.codics-aonaer-info-sys-poster-swiper-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    border-radius: 5px;
    border: 1px solid #eee;
    box-sizing: border-box;
    padding: 5px;
}

.codics-aonaer-info-sys-poster-swiper-item-card-img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    border-radius: 5px;
    box-sizing: border-box;
    overflow: hidden;
}

.codics-aonaer-info-sys-poster-swiper-item-card-img img {
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    object-fit: fill;
    left: 0;
    top: 0;
}

.codics-aonaer-info-sys-poster-swiper-item-card-img::before {
    content: attr(data-content);
    height: 90px;
    width: 100%;
    position: absolute;
    margin: auto;
    bottom: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, .8), rgba(0, 0, 0, 0));
    z-index: 2;
    line-height: 120px;
    font-size: 15px;
    color: #FFF;
    text-align: center;
}

.codics-aonaer-info-sys-poster-swiper-item-card-img::after {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    opacity: 0;
    transition: .3s;
    background: rgba(0, 0, 0, .5);
    z-index: 3;
}

.codics-aonaer-info-sys-poster-swiper-btn {
    height: 32px;
    width: 32px;
    background: #ea5b18;
    border-radius: 50%;
    color: #FFF;
    top: 59.2px !important;
}

.codics-aonaer-info-sys-poster-swiper-btn::after {
    content: '' !important;
}

.codics-aonaer-info-sys-poster-swiper::before,
.codics-aonaer-info-sys-poster-swiper::after {
    content: '';
    height: 62px;
    width: 60px;
    position: absolute;
    margin: auto;
    left: 0;
    top: 30px;
    background: linear-gradient(to right, white, rgba(255, 255, 255, 0));
    z-index: 2;
}

.codics-aonaer-info-sys-poster-swiper::after {
    left: unset !important;
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), white) !important;
}

.codics-aonaer-info-sys-poster-swiper-item img {
    transition: .3s;
}

.codics-aonaer-info-sys-poster-swiper-item:hover img {
    transform: scale(1.02);
}

.codics-aonaer-info-sys-poster-swiper-item-card-btn {
    height: 36px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 36px;
    text-align: center;
    padding: 0 20px;
    font-size: 14px;
    color: #FFF;
    transition: .3s;
    opacity: 0;
    border-radius: 18px;
    background: #ea5b18;
    z-index: 4;
}

.codics-aonaer-info-sys-poster-swiper-item:hover .codics-aonaer-info-sys-poster-swiper-item-card-img::after {
    opacity: 1;
}

.codics-aonaer-info-sys-poster-swiper-item:hover .codics-aonaer-info-sys-poster-swiper-item-card-btn {
    opacity: 1;
}
</style>